function getPriceAsNumber(price: string): number {
  const priceOnlyNumbers = String(price).replace(/[^\d.]*/g, '') // £1,739.12 -> 1739.12

  return priceOnlyNumbers.length
    ? Number(priceOnlyNumbers)
    : NaN
}

export default function formatPrice(payload: {
  price: unknown
  useFreeTextForZero?: boolean,
  currencySymbol?: any,
  prefix?: string
  toRaw?: boolean
}): string {
  if (typeof payload.price !== 'string' && typeof payload.price !== 'number') {
    return ''
  }

  const priceAsNumber = typeof payload.price === 'string'
    ? getPriceAsNumber(payload.price)
    : payload.price

  if (Number.isNaN(priceAsNumber)) {
    return ''
  }

  if (payload.toRaw) {
    return String(priceAsNumber)
  }

  if (priceAsNumber === 0 && payload.useFreeTextForZero) {
    return 'Бесплатно'
  }

  const priceLocaleString = priceAsNumber.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).replace(',00', '')

  const prefix = payload?.prefix
    ? `${payload.prefix} `
    : ''
  const currencySymbol = payload?.currencySymbol
    ? ` ${payload.currencySymbol}`
    : ''

  return `${prefix}${priceLocaleString}${currencySymbol}`
}
